import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/Modal";
import PinCodeLocationSelector from "@/components/PinCodeLocationSelector";

/**
 * Unified Address Modal Component
 * Handles both adding/editing addresses with automatic title management based on step
 */
const AddressModal = ({
  isOpen,
  onClose,
  initialValues = {},
  onComplete,
  isEdit = false,
}) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState("pin"); // Always start from pin step for both add and edit

  const getModalTitle = () => {
    // During search step, always show "Add Nearby Address"
    if (currentStep === "search") {
      return t("cart.addressModal.title"); // "Add Nearby Address"
    }
    // When editing, show "Edit Address"
    if (isEdit) {
      return t("addresses.editAddress");
    }
    // Otherwise show "Add New Address"
    return t("addresses.addNewAddress");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={getModalTitle()}>
      <PinCodeLocationSelector
        initialValues={initialValues}
        onComplete={onComplete}
        onCancel={onClose}
        isEdit={isEdit}
        onStepChange={setCurrentStep}
      />
    </Modal>
  );
};

export default AddressModal;
